import { useAuthStore } from '~~/stores/auth'
export default defineNuxtRouteMiddleware(async (_to, _from) => {
  const authStore = useAuthStore()
  const fromPath = _to.query?.from as string | undefined

  if (authStore.user)
    return navigateTo(fromPath ?? authStore.defaultUserPage)
})
